'use strict';

window.console || (window.console = {
	log: function log() {}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = '';
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');
			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
				if ($(this).hasClass('_dubble')) {
					if (!$(this).hasClass(a)) {
						$(this).next('.js-toggleBlock').find('.js-toggle').removeClass(a);
						$(this).next('.js-toggleBlock').find('.js-toggleBlock').stop().slideUp(slideSpeed);
					}
				}
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				if (/#/.test(event.currentTarget.href)) {
					// 同ページ内のページ内リンクと別ページリンクのidが被った場合の処理
					if ($(event.currentTarget).attr('href').indexOf('/') != -1) {
						if (location.pathname === $(event.currentTarget).attr('href').split('#')[0]) {
							var speed = 1200;
							scrollToObject(event, speed);
							return false;
						}
					} else {
						var speed = 1200;
						scrollToObject(event, speed);
						return false;
					}
				}
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.currentTarget.href.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;
				if (hash !== '#pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos -= 60;
					} else {
						pos -= 110;
					}
				}
				// $('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
				// lazyloadとの併用のための記述
				$.when($("html, body").animate({
					scrollTop: pos
				}, _speed, "easeOutExpo")
				// _self.preventDefault(),
				).done(function () {
					if (hash !== '#pagetop') {
						var diff = $(hash).offset().top;
						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							diff -= 60;
						} else {
							diff -= 110;
						}
						if (diff === pos) {} else {
							$("html, body").animate({
								scrollTop: diff
							}, 10, "easeOutExpo");
						}
					}
				});
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
				if (pagetopPos - $('.footer-pagetop').height() / 2 > footerPos) {
					$pagetop.addClass(a);
				} else {
					$pagetop.removeClass(a);
				}
			});
		},
		modal: function modal() {
			$('.mod-modal').on('click', function (e) {
				var HTML = '<div class="mod-modal-overlay">';
				HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><span></span></span>' + ($(e.currentTarget).find('img').prop('outerHTML').replace('di_none', '') + '</div>');
				$('body').append(HTML);
				var $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
			$('.mod-modal02').on('click', function (e) {

				var HTML = '<div class="mod-modal02-overlay">';
				var _lead = '';
				if ($(e.currentTarget).data('lead').length) {
					_lead = '<p class="fs_18 fs_md_16 mt30">' + $(e.currentTarget).data('lead') + '</p>';
				}
				var _h3 = '';
				if ($(e.currentTarget).data('h3').length) {
					_h3 = '<h3 class="_head02 mb20">' + $(e.currentTarget).data('h3') + '</h3>';
				}
				var _lead2 = '';
				if ($(e.currentTarget).data('lead2').length) {
					_lead2 = '<p class="fs_16 fs_md_14">' + $(e.currentTarget).data('lead2') + '</p>';
				}
				HTML += '<div class="mod-modal02-closeArea"></div>' + '<div class="mod-modal02-contentsWrap"><span class="mod-modal02-closeBtn"><span></span></span><div class="mod-modal02-contents"><div class="mod-modal02-contents-in">' + '<h2 class="_head">' + $(e.currentTarget).data('title') + '</h2>' + _lead + '<ul class="pure-g space-u-40 pt40">' + '<li class="pure-u-1-4 pure-u-lg-1-1 space-u-40-child ta_center">' + ('' + $(e.currentTarget).find('img').prop('outerHTML').replace('di_none', '')) + '</li>' + '<li class="pure-u-3-4 pure-u-lg-1-1 space-u-40-child">' + _h3 + _lead2 + '</li>' + '</ul></div></div></div></div>';
				// `${$(e.currentTarget).find('img').prop('outerHTML').replace('di_none','')}`+
				$('body').append(HTML);
				var $overlay = $('.mod-modal02-overlay');
				$overlay.addClass(a);
				// bodyのスクロールを止める
				var flag = false;
				var scrollTopNow;
				scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				flag = true;
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal02-closeArea, .mod-modal02-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
							// bodyのスクロールを再開
							$('.container').css({
								position: 'static'
							});
							$(window).scrollTop(scrollTopNow);
							flag = false;
						}, 400);
					});
				});
			});
			$('.mod-modal03').on('click', function (e) {
				var HTML = '<div class="mod-modal03-overlay">';
				HTML += '<div class="mod-modal03-closeArea"></div>' + '<div class="mod-modal03-contentsWrap _img"><span class="mod-modal03-closeBtn"><span></span></span><div class="mod-modal03-contents"><div class="mod-modal03-contents-in">' + '<figure class="ta_center"><img src="' + $(e.currentTarget).data('img') + '" class="" alt="一日のスケジュール"></figure>' + '</div></div></div></div>';
				$('body').append(HTML);
				var $overlay = $('.mod-modal03-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal03-closeArea, .mod-modal03-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		lazyload: function lazyload() {
			if ($(".js-lazy-img").length) {
				$(".js-lazy-img").lazyload();
			}
		},
		headerMegaMene: function headerMegaMene() {
			var $nav = $('.js-header-mega');
			var $item = $('.js-header-mega-item');
			var $block = $('.js-header-mega-item-block');
			$item.on('mouseenter', function () {
				$item.removeClass(v);
				$block.stop().slideUp(400);
				$(this).addClass(v);
				$(this).find('.js-header-mega-item-block').stop().slideDown(400);
				if ($('.js-header_white').length) {
					if (!$('.header').hasClass('is-scroll')) {
						$('.js-header_white').removeClass('header_white');
					}
				}
				$('.header').addClass('is-open');
			});
			$nav.on('mouseleave', function () {
				$item.removeClass(v);
				$block.stop().slideUp(400);
				if ($('.js-header_white').length) {
					if (!$('.header').hasClass('is-scroll')) {
						$('.js-header_white').addClass('header_white');
					}
				}
				$('.header').removeClass('is-open');
			});
			// if($('.ua-desktop').length) {
			// 	$item.on('mouseenter', function(){
			// 		$item.removeClass(v);
			// 		$block.stop().slideUp(400);
			// 		$(this).addClass(v);
			// 		$(this).find('.js-header-mega-item-block').stop().slideDown(400);
			// 		if($('.js-header_white').length) {
			// 			if(!$('.header').hasClass('is-scroll')) {
			// 				$('.js-header_white').removeClass('header_white');
			// 			}
			// 		}
			// 		$('.header').addClass('is-open');
			// 	});
			// 	$nav.on('mouseleave', function(){
			// 		$item.removeClass(v);
			// 		$block.stop().slideUp(400);
			// 		if($('.js-header_white').length) {
			// 			if(!$('.header').hasClass('is-scroll')) {
			// 				$('.js-header_white').addClass('header_white');
			// 			}
			// 		}
			// 		$('.header').removeClass('is-open');
			// 	});
			// } else {
			// 	$item.find('._link').css('pointer-events','none');
			// 	$item.on('click', function(){
			// 		$item.removeClass(v);
			// 		$block.stop().slideUp(400);
			// 		$(this).addClass(v);
			// 		if(!$(this).hasClass(a)) {
			// 			$item.removeClass(a);
			// 			$(this).addClass(a);
			// 			$(this).find('.js-header-mega-item-block').stop().slideDown(400);
			// 			if($('.js-header_white').length) {
			// 				if(!$('.header').hasClass('is-scroll')) {
			// 					$('.js-header_white').removeClass('header_white');
			// 				}
			// 			}
			// 			$('.header').addClass('is-open');
			// 		} else {
			// 			$(this).removeClass(a);
			// 			if($('.js-header_white').length) {
			// 				if(!$('.header').hasClass('is-scroll')) {
			// 					$('.js-header_white').addClass('header_white');
			// 				}
			// 			}
			// 			$('.header').removeClass('is-open');
			// 		}
			// 	});
			// }
			if ($(window).scrollTop() > '150') {
				$('.header').addClass('is-scroll');
				$('.js-header_white').removeClass('header_white');
			} else {
				$('.header').removeClass('is-scroll');
				$('.js-header_white').addClass('header_white');
			}
			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var thisScroll = $this.scrollTop();
				if (thisScroll > '150') {
					$('.header').addClass('is-scroll');
					$('.js-header_white').removeClass('header_white');
				} else {
					$('.header').removeClass('is-scroll');
					$('.js-header_white').addClass('header_white');
				}
			});
			for (var i = 0; i < $('.js-header-mega-item').length; i++) {
				// console.log($('.js-header-mega-item > a').eq(i).attr('href'));
				if ($('.inc_recruit_header').length) {
					if ($('.js-header-mega-item ._in a').eq(i).attr('href').split('/')[3]) {
						if ($('.js-header-mega-item ._in a').eq(i).attr('href').split('/')[3] === location.pathname.split('/')[3]) {
							$('.js-header-mega-item').eq(i).addClass('is-current');
						}
					}
				} else if ($('.inc_common_header_en').length) {
					if (!$('.js-header-mega-item > a').eq(i).attr('href').split('/')[2]) {} else {
						if ($('.js-header-mega-item > a').eq(i).attr('href').split('/')[2] === location.pathname.split('/')[2]) {
							$('.js-header-mega-item').eq(i).addClass('is-current');
						}
					}
				} else if ($('.js-header-mega-item > a').eq(i).attr('href') === '/' + location.pathname.split('/')[1] + '/') {
					if (!(location.pathname.split('/')[2] === 'project')) {
						$('.js-header-mega-item').eq(i).addClass('is-current');
					}
				} else if ($('.js-header-mega-item > a').eq(i).attr('href') === '/' + location.pathname.split('/')[1] + '/' + location.pathname.split('/')[2] + '/') {
					$('.js-header-mega-item').eq(i).addClass('is-current');
				}
			}
		},
		headerHamburgerMene: function headerHamburgerMene() {
			var $header = $('.header');
			var $menu = $('.js-header-menu');
			var $menucontent = $('.js-header-menu-content');
			var flag = false;
			var scrollTopNow;
			$menu.on('click', function () {
				if (!flag) {
					scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
					$header.addClass('is-menu-active');
					$menu.addClass(a);
					$menucontent.addClass(a);
					$('.container').css({
						position: 'fixed',
						width: '100%',
						top: -1 * scrollTopNow,
						left: 0
					});
					$('.header').addClass('is-open');
					flag = true;
				} else {
					$header.removeClass('is-menu-active');
					$menu.removeClass(a);
					$menucontent.removeClass(a);
					$('.container').css({
						position: 'static'
					});
					$(window).scrollTop(scrollTopNow);
					$('.header').removeClass('is-open');
					flag = false;
				}
			});
		},
		selectLink: function selectLink() {
			if ($('.js-select-link').length) {
				$('.js-select-link').val(location.pathname);
				$('.js-select-link').change(function () {
					location.href = $(this).val();
				});
			}
			if ($('.js-technology-award-select').length) {
				var directoryYear = location.pathname.split('/')[3];
				$('.js-technology-award-select').val(directoryYear);
				$('.js-technology-award-select').change(function () {
					location.href = location.pathname.replace(directoryYear, $(this).val());
				});
			}
			if ($('.js-technology-paper-select').length) {
				var _directoryYear = location.pathname.split('/')[3];
				$('.js-technology-paper-select').val(_directoryYear);
				$('.js-technology-paper-select').change(function () {
					location.href = location.pathname.replace(_directoryYear, $(this).val());
				});
			}
			if ($('.js-sustainability-esg-social-community-select').length) {
				var _directoryYear2 = location.pathname.split('/')[4];
				$('.js-sustainability-esg-social-community-select').val(_directoryYear2);
				$('.js-sustainability-esg-social-community-select').change(function () {
					location.href = location.pathname.replace(_directoryYear2, $(this).val());
				});
			}
			if ($('.js-link-current').length) {
				for (var i = 0; i < $('.js-link-current a').length; i++) {
					if (location.pathname.replace('index.html', '') === $('.js-link-current a').eq(i).attr('href')) {
						$('.js-link-current a').eq(i).addClass(a);
					}
				}
			}
		},
		animation: function animation() {
			// 下からアニメーション
			if ($('.js-inview-bottom').length) {
				$('.js-inview-bottom').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {// scroll up
						// activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 左からアニメーション
			if ($('.js-inview-left').length) {
				$('.js-inview-left').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {// scroll up
						// activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 右からアニメーション
			if ($('.js-inview-right').length) {
				$('.js-inview-right').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {// scroll up
						// activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
		},
		blockHidden: function blockHidden() {
			if ($('.js-blockHidden-purpose').length) {
				for (var i = 0; i < $('.js-blockHidden-purpose').length; i++) {
					if (location.pathname.split('/')[3] == $('.js-blockHidden-purpose').eq(i).data('purpose')) {
						$('.js-blockHidden-purpose').eq(i).addClass('di_none');
					}
				}
			}
		},
		currentLink: function currentLink() {
			if ($('.js-current').length) {
				for (var i = 0; i < $('.js-current').length; i++) {
					if (location.pathname.replace('index.html', '') === $('.js-current').eq(i).attr('href')) {
						$('.js-current').eq(i).addClass(a);
					}
				}
			}
			if ($('.js-current-community').length) {
				for (var i = 0; i < $('.js-current-community').length; i++) {
					if (location.pathname.replace('index.html', '').indexOf($('.js-current-community').eq(i).attr('href').replace('community/', 'community')) != -1) {
						$('.js-current-community').eq(i).addClass(a);
					}
				}
			}
		},
		sideMenu: function sideMenu() {
			var $btn = $('.js-sideMenuBtn');
			$btn.on('click', function () {
				var $menu = $(this).parent('.js-sideMenu');
				if ($menu.hasClass(a)) {
					$menu.removeClass(a);
				} else {
					$menu.addClass(a);
				}
			});
		},
		fileSize: function fileSize() {
			var setFileSize = function setFileSize(className) {
				// console.log(className);
				if ($(className).length) {
					$(className).each(function () {
						$(this).text('' + bytesToSize($(this).text()) + '');
					});
				}
				function bytesToSize(bytes) {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if (bytes === 0) {
						return 'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if (i === 0) {
						return bytes + ' ' + sizes[i];
					}
					return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
				}
			};
			setFileSize('.rt_cf_n_attachment_file_size');
			setFileSize('.js-fileSize');
			$('.rt_cf_n_attachment_file_size').removeClass('di_none');
		},
		newsViewMore: function newsViewMore() {
			var $btn = $('.js-newsViewMore');
			var $year = $('.js-newsViewMore-year').text();
			for (var i = 0; i < $btn.length; i++) {
				var $setLink = $btn.eq(i).attr('href').replace('$year$', $year);
				$btn.eq(i).attr('href', $setLink);
			}
		},
		openSearchBox: function openSearchBox() {
			var $btn = $('.js-search_open');
			var $btnClose = $('.js-close_bg');
			$btn.on('click', function () {
				$('.header-search_box').addClass(a);
			});
			$btnClose.on('click', function () {
				$('.header-search_box').removeClass(a);
			});
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.pageTop();
			_this.modal();
			_this.lazyload();
			_this.headerMegaMene();
			_this.headerHamburgerMene();
			_this.selectLink();
			_this.animation();
			_this.blockHidden();
			_this.currentLink();
			_this.sideMenu();
			_this.fileSize();
			_this.newsViewMore();
			_this.openSearchBox();
			svg4everybody();
		}
	};

	$(function () {
		return FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript();
	});
})(window.jQuery);
$(window).on('load', function () {
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-move';
	var slide = function slide() {
		if ($('.mod-slide01').length) {
			$('.mod-slide01').slick({
				autoplay: false,
				// autoplaySpeed: 5000,
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				dots: false,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}]
			});
			$('.mod-slide01Wrap').removeClass('is-hidden');
			for (var i = 0; i < $('.mod-slide01').length; i++) {
				if ($('.mod-slide01').eq(i).find('.slick-prev')) {
					var imgHeight = $('.mod-slide01').eq(i).find('._item .mod-newIconWrap').eq(0).outerHeight() / 2;
					var arrowHeight = $('.mod-slide01').eq(i).find('.slick-prev').eq(0).outerHeight() / 2;
					// console.log($('.mod-slide01').eq(i).find('._item img').eq(0).outerHeight(),$('.mod-slide01').eq(i).find('.slick-prev').eq(0).outerHeight());
					var arrowpos = imgHeight - arrowHeight;
					$('.mod-slide01').eq(i).find('.slick-prev').css('top', arrowpos);
					$('.mod-slide01').eq(i).find('.slick-next').css('top', arrowpos);
				}
			}
		}
		if ($('.mod-slide02').length) {
			$('.mod-slide02').slick({
				autoplay: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				dots: false,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						infinite: true
					}
				}]
			});
			$('.mod-slide02Block').removeClass('is-hidden');
			if ($('.mod-slide02 .slick-prev').find('.slick-prev')) {
				var _imgHeight = $('.mod-slide02 ._item .mod-newIconWrap').eq(0).outerHeight() / 2;
				var _arrowHeight = $('.mod-slide02 .slick-prev').eq(0).outerHeight() / 2;
				var _arrowpos = _imgHeight - _arrowHeight;
				$('.mod-slide02 .slick-prev').css('top', _arrowpos);
				$('.mod-slide02 .slick-next').css('top', _arrowpos);
			}
			// $('.top-slide02 .slick-active').eq(0).prev($('.slick-slide')).addClass('is-hidden');
			// $('.top-slide02').on('afterChange', function(event, slick, currentSlide){
			// 	$('.top-slide02 .slick-slide').removeClass('is-hidden');
			// 	$('.top-slide02 .slick-active').eq(0).prev($('.slick-slide')).addClass('is-hidden');
			// });
		}
	};
	var easeScrollHash = function easeScrollHash() {
		if (location.hash) {
			$('html, body').css('display', 'none');
			setTimeout(function () {
				$('html, body').css('display', 'block');
				var _hash = '#' + location.hash.split('#')[1];
				var pos = $(_hash).offset().top;
				if ($(window).width() < 1024) {
					pos -= 60;
				} else {
					pos -= 110;
				}
				// $('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
				// lazyloadとの併用のための記述
				$.when($("html, body").animate({
					scrollTop: pos
				}, 1200, "easeOutExpo")
				// _self.preventDefault(),
				).done(function () {
					var diff = $(_hash).offset().top;
					if ($(window).width() < 1024) {
						diff -= 60;
					} else {
						diff -= 110;
					}
					if (diff === pos) {} else {
						$("html, body").animate({
							scrollTop: diff
						}, 10, "easeOutExpo");
					}
				});
			}, 100);
		}
	};
	slide();
	easeScrollHash();
});